function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Check for Safari
            if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                $(".filter-menu").addClass("is-safari");
            }
          
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs
            $('.pt-display-dropdown').each(function( index ) {
                $(this).find('h4').after($(this).find('.filter-clear'));
            });

            $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).parent().find('.menu-trigger').length === 0) {
                if($(this).find('li.selected').length) {
                  var selected = $.map(
                    $(this).find('li.selected a'),
                    function(element){
                      return $(element).text();
                    }
                  ).join(", ");

                  if (selected.length < 30) {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + selected +'</div>');
                  } else {
                    $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">' + $(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                  $(this).before('<div class="menu-trigger" tabindex="0" aria-label="' + $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                }
              }
            });

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested));
              })
            })
            var allProductTitles = [
              
            ];

            

          }

          pt_on_load();

          window.pt_on_load = pt_on_load

          // Mobile filter button
          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger', function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
            $(this).next('.scroll-content').toggleClass('dropdown-open')
            if ($(this).next('.scroll-content').hasClass('dropdown-open')) {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection expanded');
            } else {
              $(this).attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
            }
          });
          
          $(document).on('keydown', '.pt-display-dropdown .menu-trigger', function(e) {
            if(e.which == 13 || e.which == 32 ) { // return or space keys
              e.preventDefault();
              $(this).click();
            }
          });
          
          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).removeClass('dropdown-open');
            $(this).slideUp('fast');
            $(this).prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });
          
          $(document).on('focusout', '.pt-display-dropdown .scroll-content li:last-child', function() {
            $(this).closest('.scroll-content').removeClass('dropdown-open');
            $(this).closest('.scroll-content').slideUp('fast');
            $(this).closest('.scroll-content').prev('.menu-trigger').attr('aria-label', $(this).closest('.filter-group').find('h4').text() + ' dropdown selection collapsed');
          });

          // Apply button
          
          $('.filter-menu').append('<div class="filter-group"><button type="button" class="pt-apply pt-apply-disabled">Apply</button></div>');
          $(document).on('click', '.pt-apply', function(e) {
              if ($('.filter-menu').data('current-url')) {
                  window.location = $('.filter-menu').data('current-url');
              }
          });
          
          $(document).on('click', '.filter-group li.collection-container a, .filter-group a.filter-clear', function(e) {
              e.preventDefault();
              e.stopPropagation();
          
              var current_url = $(this).attr('href');
              $('.filter-menu').data('current-url', current_url).fadeTo('slow', 0.8);
          
              $.get(current_url, function(data) {
                  // Replace filter menu with the new one
                  var elem = $(data).find('.filter-menu').first();
                  $('.filter-menu').replaceWith(elem).fadeTo('fast', 1.0);
          
                  // After new content is loaded, update the year filters based on the new product titles
                  updateYearFiltersAfterReload(data);
          
                  // Re-append the apply button and set up other actions
                  $('.filter-menu').data('current-url', current_url).append('<div class="filter-group"><button type="button" class="pt-apply">Apply</button></div>');
                  pt_on_load();  // This function seems to be used for additional setup, keep it if necessary
                  $('.filter-menu .pt-mobile-header a').trigger('click');
              });
          });
          
          // Function to update year filters based on visible product titles
          function updateYearFiltersAfterReload(data) {
            if (!window.location.href.includes("chevrolet") && !window.location.href.includes("camaro")) {
              var validYearRanges = new Set();
              var validYears = new Set();
          
              // Extract the product titles from the new data (from the response)
              var products = $(data).find('.collection-grid__wrapper .grid__item .grid-product__title');
              
              // Loop through the product titles and check for year ranges and single years
              products.each(function() {
                  var title = $(this).text().trim();
          
                  // Ignore products containing "Billet"
                  if (/billet/i.test(title)) return;
          
                  // Extract year range (YYYY-YYYY)
                  var rangeMatch = title.match(/(\d{4}-\d{4})/);
                  if (rangeMatch) {
                      validYearRanges.add(rangeMatch[0]);
                  }
          
                  // Extract a single year (YYYY) if there's no range match
                  var singleYearMatch = title.match(/\b(19\d{2}|20\d{2})\b/);
                  if (singleYearMatch && !rangeMatch) {
                      validYears.add(singleYearMatch[0]);
                  }
              });
          
              // Now update each year filter element based on valid years/ranges
              var yearFilters = document.querySelectorAll('.filter-group-vehicle-year li');
              
              yearFilters.forEach(function(filter) {
                  // Try to extract a range or a single year from the filter's class
                  var filterRangeMatch = filter.className.match(/(\d{4}-\d{4})/);
                  var filterSingleYearMatch = filter.className.match(/\b(19\d{2}|20\d{2})\b/);
                  var isValid = false;
          
                  if (filterRangeMatch) {
                      isValid = validYearRanges.has(filterRangeMatch[0]);
                  } else if (filterSingleYearMatch) {
                      isValid = validYears.has(filterSingleYearMatch[0]);
                  }
          
                  filter.style.display = isValid ? "inherit" : "none";
              });
            }
          }
          


          // Ajax
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();

document.addEventListener('DOMContentLoaded', function() {
    function updateYearFiltersOnLoad() {
      if (!window.location.href.includes("chevrolet") && !window.location.href.includes("camaro")) {
        var validYearRanges = new Set();
        var validYears = new Set();

        // Extract the product titles from the page
        var products = document.querySelectorAll('.collection-grid__wrapper .grid__item .grid-product__title');

        // Loop through the product titles and check for year ranges and single years
        products.forEach(function(product) {
            var title = product.textContent.trim();

            // Ignore products containing "Billet"
            if (/billet/i.test(title)) return;

            // Extract year range (YYYY-YYYY)
            var rangeMatch = title.match(/(\d{4}-\d{4})/);
            if (rangeMatch) {
                validYearRanges.add(rangeMatch[0]);
            }

            // Extract a single year (YYYY) if there's no range match
            var singleYearMatch = title.match(/\b(19\d{2}|20\d{2})\b/);
            if (singleYearMatch && !rangeMatch) {
                validYears.add(singleYearMatch[0]);
            }
        });

        // Now update each year filter element based on valid years/ranges
        var yearFilters = document.querySelectorAll('.filter-group-vehicle-year li');

        yearFilters.forEach(function(filter) {
            var filterRangeMatch = filter.className.match(/(\d{4}-\d{4})/);
            var filterSingleYearMatch = filter.className.match(/\b(19\d{2}|20\d{2})\b/);
            var isValid = false;

            if (filterRangeMatch) {
                isValid = validYearRanges.has(filterRangeMatch[0]);
            } else if (filterSingleYearMatch) {
                isValid = validYears.has(filterSingleYearMatch[0]);
            }

            filter.style.display = isValid ? "" : "none"; // Use default display (inherit) or hide based on validity
        });
      }
    }

    updateYearFiltersOnLoad(); // Call the function on DOMContentLoaded
});

